var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 63.9995C49.6731 63.9995 64 49.6726 64 31.9995C64 14.3264 49.6731 -0.000488281 32 -0.000488281C14.3269 -0.000488281 0 14.3264 0 31.9995C0 49.6726 14.3269 63.9995 32 63.9995Z",
    fill: "#007AB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1197 34.5746V47.7675H43.4708V35.4587C43.4708 32.3681 42.3664 30.2575 39.597 30.2575C37.4835 30.2575 36.228 31.6785 35.6736 33.0544C35.4722 33.5461 35.4203 34.2289 35.4203 34.9185V47.7669H27.7708C27.7708 47.7669 27.8735 26.92 27.7708 24.762H35.4209V28.022C35.4055 28.0477 35.3838 28.0728 35.3701 28.0973H35.4209V28.022C36.4374 26.4579 38.2502 24.2218 42.3145 24.2218C47.3469 24.2218 51.1197 27.5098 51.1197 34.5746ZM19.7688 13.6729C17.1523 13.6729 15.4404 15.3904 15.4404 17.647C15.4404 19.8557 17.1026 21.6229 19.6684 21.6229H19.7181C22.386 21.6229 24.0448 19.8557 24.0448 17.647C23.994 15.3904 22.386 13.6729 19.7688 13.6729ZM15.895 47.7675H23.5417V24.762H15.895V47.7675Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e86c387447082971584739318e29a875.svg";
export { ForwardRef as ReactComponent };